import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import { useFormContextRequester } from '../utils/_utils'
import { ucfirst } from 'libs/ordoclic/src/lib/utilities'

const LastName = () => {
    const { control } = useFormContextRequester()

    return (
        <Controller
            control={control}
            name="lastName"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Nom d’exercice"
                    placeholder="Nom d’exercice"
                    locked
                    disabled
                    status={{
                        error,
                        valid: (field.value?.trim().length ?? 0) > 0,
                    }}
                    {...field}
                    value={ucfirst(field?.value ?? '')}
                />
            )}
        />
    )
}

export default LastName
